import { defineNuxtPlugin } from "#app";
import { DateService } from "@spoferan/spoferan-ts-core";
export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      date: (date, format = null) => {
        return new DateService(date, format, nuxtApp.$i18n?.locale.value ?? "de");
      }
    }
  };
});
